(function () {
	let swiperInstance = null;

	function initSwiper() {
		if (!swiperInstance) {
			const wrapper = document.querySelector(".slider-demo-wrapper");
			wrapper.classList.add("swiper-wrapper");

			const elements = document.querySelectorAll(
				".slider-demo > .swiper-wrapper > *"
			);

			elements.forEach((element) => {
				element.classList.add("swiper-slide");
			});

			swiperInstance = new Swiper(".slider-demo", {
				direction: "vertical",
				speed: 400,
				effect: "creative",
				creativeEffect: {
					prev: {
						translate: [0, "-20%", -1],
					},
					next: {
						translate: [0, "100%", 0],
					},
				},
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: false,
					sensitivity: 1,
					thresholdDelta: 20,
					thresholdTime: 200,
				},
				touchReleaseOnEdges: false,
				touchRatio: window.innerWidth <= 1200 ? 1 : 0.2,
				longSwipes: true,
				freeMode: false,
				on: {
					slideChangeTransitionStart: changeNavStyle,
				},
			});

			changeNavStyle();

			function changeNavStyle() {
				const stickyNav = document.querySelector(".shopify-section-header");
				const activeSlide = document.querySelector(
					".swiper-slide-active > .background"
				);
				let backgroundColor;
				let isLightBackground;

				if (activeSlide) {
					backgroundColor =
						window.getComputedStyle(activeSlide).backgroundColor;
					isLightBackground = isLightColor(backgroundColor);
				}

				if (isLightBackground) {
					stickyNav.classList.add("color-background-1");
					stickyNav.classList.remove("color-background-2");
				} else {
					stickyNav.classList.add("color-background-2");
				}
			}

			function isLightColor(color) {
				const rgb = color.match(/\d+/g).map(Number);
				const luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
				return luminance > 186;
    }
  }
}

function syncMobileHeight() {
        const main = document.querySelector("main.home_page_slider");
        if (!main) return;

        if (window.innerWidth <= 1200) {
            const viewport = window.visualViewport;

            // Не змінюємо макет під час масштабування сторінки.
            if (viewport && viewport.scale !== 1) return;

            const visibleHeight = viewport
                ? viewport.height
                : window.innerHeight;

            const styles = getComputedStyle(main);
            const countdown =
                parseFloat(styles.getPropertyValue("--countdown-bar-height")) || 0;
            const announcement =
                parseFloat(styles.getPropertyValue("--ann-height")) || 0;

            main.style.setProperty(
                "--mobile-slider-height",
                Math.max(0, visibleHeight - countdown - announcement) + "px"
            );
        } else {
            main.style.removeProperty("--mobile-slider-height");
        }

        requestAnimationFrame(function () {
            if (swiperInstance) swiperInstance.update();
        });
    }

    initSwiper();
    syncMobileHeight();

    window.addEventListener("resize", syncMobileHeight);

    if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", syncMobileHeight);
    }

    document.addEventListener("shopify:section:load", function () {
        initSwiper();
        syncMobileHeight();
    });
})();